import api from './api';

const institutionService = {
    // Get current admin's institution
    getMyInstitution: async () => {
        const response = await api.get('/institutions/me');
        return response.data;
    },

    // Get specific institution
    getInstitution: async (id) => {
        const response = await api.get(`/institutions/${id}`);
        return response.data;
    },

    // Get stats
    getStats: async (id) => {
        const response = await api.get(`/institutions/${id}/stats`);
        return response.data;
    },

    // Get teachers
    getTeachers: async (id, params = {}) => {
        const response = await api.get(`/institutions/${id}/teachers`, { params });
        return response.data;
    },

    // Add teacher
    addTeacher: async (id, teacherData) => {
        const response = await api.post(`/institutions/${id}/teachers`, teacherData);
        return response.data;
    },

    // Delete teacher
    deleteTeacher: async (id, teacherId) => {
        await api.delete(`/institutions/${id}/teachers/${teacherId}`);
    },

    // Get students
    getStudents: async (id, params = {}) => {
        const response = await api.get(`/institutions/${id}/students`, { params });
        return response.data;
    },

    // Get student progress details (Admin)
    getStudentProgress: async (institutionId, studentId) => {
        const response = await api.get(`/institutions/${institutionId}/students/${studentId}/progress`);
        return response.data;
    },

    // Add student
    addStudent: async (id, studentData) => {
        const response = await api.post(`/institutions/${id}/students`, studentData);
        return response.data;
    },
};

export default institutionService;
